module.exports = __webpack_public_path__ + "img/carousel-4.5e31c199.jpg";